import Button from "../../../components/button/button";
import AreaService, { AreaOutput } from "../../../services/AreasService";
import MultiSelect from "../../../components/multi-select/multi-select";
import AcessoPaineis from "../acesso-paineis/acesso-paineis";
import PainelService, { PainelOutput } from "../../../services/PainelService";

import { useCallback, useEffect, useState } from "react";

import "./usuario-acesso.css";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

interface UsuarioProps {
  cancelaAcesso?: () => void;
  moduloEscolhido: any;
  retornaAcessos?: (lista1: any, lista2: any) => void;
  listaDeAcessos: {
    areasEscolhidas: any[],
    paineisEscolhidos: any[]
  }
}

const UsuarioAcesso = ({ cancelaAcesso, moduloEscolhido, retornaAcessos, listaDeAcessos }: UsuarioProps) => {
  const [acessoTotal, setAcessoTotal] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  const [selectedArea, setSelectedArea] = useState<AreaOutput[]>(listaDeAcessos.areasEscolhidas.filter(x => x['modulo'] === moduloEscolhido) ?? []);
  const [selectedPaineis, setSelectedPaineis] = useState<PainelOutput[]>(listaDeAcessos.paineisEscolhidos ?? []);

  const [listaDeAreas, setListaDeAreas] = useState<AreaOutput[]>([]);
  const [listaDePaineis, setlistaDePaineis] = useState<PainelOutput[]>([]);

  const tipoDePermissaoDeAcesso = (status: boolean) => {
    setSelectedArea([])
    if(status){
      const areaTodos = listaDeAreas.find(x => x['modulo'] === moduloEscolhido && x['nome'] === 'TODOS');
      if (areaTodos) ObtemListaDeAreasComAcesso(areaTodos);
    }
    setAcessoTotal(status)
  }

  const ObtemListaDeAreasPorModulo = useCallback(async () => {
    let areasDoLicenciado = await (AreaService.obterListaDeAreasPorModulo(moduloEscolhido));
    setListaDeAreas(areasDoLicenciado.content.areas)
    setLoading(false);
  }, [setListaDeAreas, setLoading, moduloEscolhido]);

  const ObtemListaDePaineis = useCallback(async () => {
    let paineis = await PainelService.obterListaDePaineisPorModulo(moduloEscolhido);
    setlistaDePaineis(paineis.content.paineis)
    setLoading(false);
  }, [setlistaDePaineis, setLoading, moduloEscolhido]);


  useEffect(() => {
    setLoading(true);
    ObtemListaDeAreasPorModulo();
    ObtemListaDePaineis();

    if(listaDeAcessos.areasEscolhidas.find(x => x['nome'] === 'TODOS' && x['modulo'] === moduloEscolhido)) {
      setAcessoTotal(true)
    }

  }, [moduloEscolhido, ObtemListaDeAreasPorModulo, ObtemListaDePaineis, listaDeAcessos]);

  const ObtemListaDeAreasComAcesso = (area: any) => {
    setSelectedArea((prevSelected) => {
      const exists = prevSelected.some((item) => item.id === area.id);
      if (exists) {
        return prevSelected.filter((item) => item.id !== area.id);
      }
      return [...prevSelected, area];
    });
  }

  const ObtemListaDePaineisComAcesso = (painel: PainelOutput) => {
    setSelectedPaineis((prevSelected) => {
      const exists = prevSelected.some((item) => item.id === painel.id);
      if (exists) {
        return prevSelected.filter((item) => item.id !== painel.id);
      }
      return [...prevSelected, painel];
    });
  };
  return (
    <>
      <div className={'formulario__acesso'}>
        <h3>Permissão de acesso aos dados</h3>

        {/* Skeleton para as opções de Radio */}
        {loading ? (
          <div style={{ marginBottom: '20px' }}>
            <Skeleton height={25} count={2} style={{ marginBottom: '10px' }} />
          </div>
        ) : (
          <>
            <div className="row">
              <input
                type="radio"
                name="options"
                checked={acessoTotal === true}
                onChange={() => tipoDePermissaoDeAcesso(true)} />
              <label 
                onClick={() => tipoDePermissaoDeAcesso(true)}>
                  Acesso aos dados de todas as Áreas Organizacionais
              </label>
            </div>
            <div className="row">
              <input type="radio" name="options" checked={acessoTotal === false} onChange={() => tipoDePermissaoDeAcesso(false)} />
              <label
                onClick={() => tipoDePermissaoDeAcesso(false)}> 
                Acesso aos dados por Áreas Organizacional
              </label>
            </div>
          </>
        )}

        <div className="row" style={{ marginBottom: '10px', width: '100%' }}>
          {!acessoTotal &&
            <div className="formulario__colunas">
              {loading ? (
                <Skeleton height={40} />
              ) : (
                <MultiSelect
                  disabled={acessoTotal}
                  options={listaDeAreas}
                  placeholder="Selecione as Areas"
                  onClickAcao={ObtemListaDeAreasComAcesso}
                  optionComAcesso={selectedArea}
                />
              )}
            </div>
          }
        </div>

        {/* Skeleton para a lista de painéis */}
        {loading ? (
          <div style={{ marginTop: '20px' }}>
            <Skeleton height={50} width={`60%`} />
            <Skeleton count={6} height={20} style={{ marginBottom: '10px', height: '324px' }} />
          </div>
        ) : (
          <AcessoPaineis
            listaPaineis={listaDePaineis}
            checkedLista={ObtemListaDePaineisComAcesso}
            paineisComAcesso={selectedPaineis}
          />
        )}

        <div style={{ display: 'flex', marginTop: '20px' }}>
          <Button
            classes='formulario__button--cancelar'
            style={{ margin: 8 }}
            text={"Cancelar"}
            onClick={cancelaAcesso}
          />
          {loading ? (
            <div style={{ margin: 8 }}><Skeleton width={100} height={40} /></div>
          ) : (
            <Button
              classes='formulario__button'
              style={{ margin: 8 }}
              text={"Salvar"}
              onClick={() => retornaAcessos && retornaAcessos(selectedArea, selectedPaineis)}
            />
          )}
        </div>
      </div>

    </>
  )
}

export default UsuarioAcesso;
